import * as React from "react";
import { AuthContextType } from "./types";

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
export const AuthContext = React.createContext<AuthContextType>(null!);
